import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { FolderView } from '../../Types/enums';
import { isClassicUiSearch } from '../../util/classicUi';
import Folder from '../Folder/Folder';

export const LibraryRedirect: React.FC<{
  fallbackElement: React.ReactElement;
}> = ({ fallbackElement }) => {
  const targetUrl = import.meta.env.VITE_LIBRARY_URL?.trim();

  useEffect(() => {
    if (targetUrl) {
      window.location.replace(targetUrl);
    }
  }, [targetUrl]);

  return targetUrl ? null : fallbackElement;
};

const PromptLibraryRoute: React.FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  if (isClassicUiSearch(location.search) || params.has('promptId')) {
    return <Folder selectedView={FolderView.PROMPTS} />;
  }

  return <LibraryRedirect fallbackElement={<Folder selectedView={FolderView.PROMPTS} />} />;
};

export default PromptLibraryRoute;
